/**
 * Dock KO'RINADIGAN marshrutlar (SPEC §5).
 *
 * Nega alohida fayl: React Fast Refresh komponent faylida FAQAT
 * komponent eksport qilinganda ishlaydi. `Dock.tsx` dan konstanta ham
 * eksport qilinganda lint ogohlantirdi va u haq — aralash fayl
 * o'zgarganda butun modul qayta yuklanadi (`admin/lib.ts` da xuddi
 * shu sabab yozilgan).
 *
 * Fokusli ekranlarda (`shop`, `settings`, `match`, `search`, `call`,
 * `room`) dock YO'Q — u yerda foydalanuvchi bitta ishni bajaradi va
 * Telegram'ning `BackButton` i chiqish yo'lini beradi.
 */

// `/top` faza 2 da qo'shildi — SPEC §5 dock ro'yxatida u bor.
// `/chats` faza 3 da qo'shildi — SPEC §5 dock ro'yxatida u bor.
export const DOCK_ROUTES = ['/', '/top', '/chats', '/profile'] as const;

export function dockVisible(pathname: string): boolean {
  return (DOCK_ROUTES as readonly string[]).includes(pathname);
}
